/* global Litepicker */
const datepickerElem = document.querySelectorAll('.mod-datepicker input');

datepickerElem.forEach((elem) => {
  // eslint-disable-next-line no-new
  new Litepicker({
    lang: localData.locale,
    element: elem,
    format: 'DD-MM-YYYY',
    plugins: ['mobilefriendly'],
    mobilefriendly: {
      breakpoint: 767,
    },
    buttonText: {
      previousMonth: '<i class="icon : icon-chevron-left"></i>',
      nextMonth: '<i class="icon : icon-chevron-right"></i>',
    },
  });
});
